/* LUXURIA – Kaufbereich für Rückfahrkameras (nur geladen, wenn layout/theme.liquid das Produkt als echte
   Rückfahrkamera erkennt; 360°/Surround View ausgeschlossen). Wiederherstellen: Git-Tag "zurueckcam2".

   Die Produktoptionen-App (APO) bleibt der Motor: Preise, Optionen und Warenkorb-Eigenschaften kommen weiter
   aus der App. Dieses Skript
   - ersetzt nur die sichtbare Einbau-Auswahl durch zwei Karten ("Nur Nachrüstsatz" / "Nachrüstsatz inkl. Einbau")
     und setzt dabei das App-Feld "Einbau-Service" im Hintergrund,
   - wählt keine kostenpflichtige Einbau-Option vor,
   - macht die FIN zur sichtbaren Pflichtangabe (17 Zeichen) und verhindert das Hinzufügen ohne gültige FIN.
   Findet das Skript die erwarteten App-Felder nicht, ändert es nichts (die Seite bleibt wie bisher). */
(function () {
  'use strict';

  var body = document.body;
  if (!body || !body.classList.contains('lux-rearcam') || !window.luxRearCam) return;

  var VIN_RE = /^[A-HJ-NPR-Z0-9]{17}$/;
  var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var money = function (cents) { return fmt.format(cents / 100); };

  function surchargeCents(text) {
    // "(+399.00 €)" bzw. "(+399,00 €)"
    var m = /\(\+\s*([\d.,]+)\s*€\)/.exec(text || '');
    if (!m) return null;
    var raw = m[1];
    if (/,\d{2}$/.test(raw)) raw = raw.replace(/\./g, '').replace(',', '.');
    else raw = raw.replace(/,/g, '');
    var n = parseFloat(raw);
    return isNaN(n) ? null : Math.round(n * 100);
  }

  function findOptions(info) {
    var einbau = null, fin = null;
    info.querySelectorAll('.mw-option').forEach(function (opt) {
      var sel = opt.querySelector('select');
      if (sel && !einbau) {
        var texts = Array.prototype.map.call(sel.options, function (o) { return o.text; });
        var withIdx = texts.findIndex(function (t) { return /mit\s+montage/i.test(t); });
        var withoutIdx = texts.findIndex(function (t) { return /ohne\s+montage/i.test(t); });
        if (withIdx > -1 && withoutIdx > -1) einbau = { root: opt, select: sel, withIdx: withIdx, withoutIdx: withoutIdx };
      }
      var inp = opt.querySelector('input[type="text"]');
      if (inp && !fin) {
        var title = (opt.textContent || '').toLowerCase();
        if (inp.maxLength === 17 || /fahrgestell|fin\b|fahrzeug-ident/.test(title)) fin = { root: opt, input: inp };
      }
    });
    return { einbau: einbau, fin: fin };
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function setup(info, found) {
    if (setup.done) return;
    setup.done = true;
    var base = window.luxRearCam.price;
    // Händlerpreis (D-032): Rabatt nur auf den Nachrüstsatz, Montage-Aufpreis bleibt Normalpreis – gleiche Rundung wie Shopify
    var hrRate = Number(window.luxRearCam.hrRate) || 0;
    var regularBase = base;
    if (hrRate > 0) base = regularBase - Math.round(regularBase * hrRate / 100);
    var ctx = { choice: null };
    var einbau = found.einbau, fin = found.fin;

    /* ---------- Preiszeile unter dem Titel ---------- */
    var priceLine = el('div', 'lux-rc-price', '<span class="lux-rc-price__value"></span><span class="lux-rc-price__tax">inkl. MwSt.</span>');
    var themePrice = info.querySelector('.price');
    if (themePrice && themePrice.parentNode) themePrice.parentNode.insertBefore(priceLine, themePrice);
    var priceValue = priceLine.querySelector('.lux-rc-price__value');
    if (hrRate > 0) {
      var hrNote = el('div', 'lux-rc-hr', '<s>' + money(regularBase) + '</s> <strong>Dein Händlerpreis –' + hrRate + ' %</strong> <span>(auf die Kamera-Hardware inkl. Hardware-Optionen; Dienstleistungen wie SFD2-Codierung und Remote-Freischaltung zum Normalpreis; Einbau durch LUXURIA ist im Händlerzugang nicht wählbar)</span>');
      hrNote.style.cssText = 'margin:-.2rem 0 1rem;font-size:1.4rem;line-height:1.5';
      priceLine.parentNode.insertBefore(hrNote, priceLine.nextSibling);
    }
    if (hrRate > 0) {
      // APO-Gesamtpreis (am Warenkorb-Button) rechnet mit dem Normalpreis: Händlerrabatt des Nachrüstsatzes abziehen.
      // Wie der Shopify-Rabatt: nur das Grundprodukt rabattiert, Optionen/Montage unverändert. Die APO-Summe ist mengenunabhängig.
      var hrDiff = regularBase - base;
      var parseCents = function (t) {
        var m = /([\d.]+,\d{2})\s*€/.exec(t || '');
        return m ? Math.round(parseFloat(m[1].replace(/\./g, '').replace(',', '.')) * 100) : null;
      };
      // Hardware-Aufpreise nur rabattieren, wenn der Händlercode auch die Hilfsprodukte abdeckt (Theme-Schalter aus layout/theme.liquid)
      var hrHwOk = !!window.luxRearCam.hrHw;
      var hrSurcharges = function () {
        var r = { hardware: 0, remote: 0, service: 0 };
        info.querySelectorAll('.mw-option select').forEach(function (s) {
          var o = s.options[s.selectedIndex];
          if (!o) return;
          var cents = surchargeCents(o.text);
          if (!cents) return;
          // Remote und – bei umgestellten Produkten (hrSplit) – Montage/SFD2 kommen als eigene Zusatzprodukte zum Normalpreis
          if (/fernzugriff|remote/i.test(o.text) || (window.luxRearCam.hrSplit && /montage|einbau|sfd2|codier/i.test(o.text))) r.remote += cents;
          else if (/montage|einbau|sfd2|codier|freischalt/i.test(o.text)) r.service += cents;
          else r.hardware += cents;
        });
        return r;
      };
      var hrPaidNote = el('p', 'lux-rc-hr-paid', 'Für diese Auswahl gilt der Normalpreis: Kamera und Dienstleistung (z. B. SFD2-Codierung) werden bei diesem Produkt gemeinsam berechnet. Ohne diese Option gilt Ihr Händlerpreis.');
      hrPaidNote.hidden = true;
      hrPaidNote.style.cssText = 'margin:.4rem 0 0;font-size:1.3rem;color:#8a5a00';
      var apoBox = document.querySelector('.mw-apo-price-custom');
      if (apoBox && apoBox.parentNode) apoBox.parentNode.insertBefore(hrPaidNote, apoBox.nextSibling);
      var fixTotals = function () {
        document.querySelectorAll('.mw-apo-price-custom .mw-text--style-strong, .mws-subtotal-price span').forEach(function (n) {
          var t = n.textContent;
          if (n.getAttribute('data-lux-hr') === t) return;
          var c = parseCents(t);
          if (c === null) return;
          // Gewählte APO-Aufpreise einordnen: Hardware (z. B. Business Navigation) wird mit rabattiert,
          // Remote ist ein eigenes Produkt (Normalpreis), Dienstleistungen (Montage, SFD2/Codierung) → gesamte Konfiguration zum Normalpreis.
          var mix = hrSurcharges();
          var service = mix.service > 0;
          if (hrPaidNote) hrPaidNote.hidden = !service;
          if (service) { n.setAttribute('data-lux-hr', t); return; }
          var hwBase = regularBase + (hrHwOk ? mix.hardware : 0);
          if (!hrHwOk && mix.hardware > 0) { if (hrPaidNote) hrPaidNote.hidden = false; n.setAttribute('data-lux-hr', t); return; }
          var v = money(c - Math.round(hwBase * hrRate / 100));
          n.textContent = v;
          n.setAttribute('data-lux-hr', v);
        });
      };
      new MutationObserver(fixTotals).observe(info.closest('.product-info-wrap-content') || document.body, { subtree: true, childList: true, characterData: true });
      fixTotals();
    }

    /* ---------- Einbau: zwei Karten ---------- */
    var cards = null, errCards = null;
    if (einbau) {
      var sur = surchargeCents(einbau.select.options[einbau.withIdx].text);
      if (sur === null) { einbau = null; }
      else {
        var withTotal = base + sur;
        cards = el('div', 'lux-rc-choice');
        cards.innerHTML =
          '<p class="lux-rc-choice__title" id="LuxRcChoiceTitle">Ausführung wählen <span aria-hidden="true">*</span></p>' +
          '<div class="lux-rc-choice__list" role="radiogroup" aria-labelledby="LuxRcChoiceTitle" aria-required="true">' +
            '<button type="button" class="lux-rc-card" role="radio" aria-checked="false" data-rc="kit">' +
              '<span class="lux-rc-card__dot" aria-hidden="true"></span>' +
              '<span class="lux-rc-card__text"><span class="lux-rc-card__name">Nur Nachrüstsatz</span>' +
              '<span class="lux-rc-card__desc">Ohne Montage durch LUXURIA</span></span>' +
              '<span class="lux-rc-card__price">' + money(base) + '</span>' +
            '</button>' +
            '<button type="button" class="lux-rc-card" role="radio" aria-checked="false" data-rc="montage">' +
              '<span class="lux-rc-card__dot" aria-hidden="true"></span>' +
              '<span class="lux-rc-card__text"><span class="lux-rc-card__name">Nachrüstsatz inkl. Einbau</span>' +
              '<span class="lux-rc-card__desc">Montage in unserer Werkstatt in Heidenheim</span></span>' +
              '<span class="lux-rc-card__price">' + money(withTotal) + '</span>' +
            '</button>' +
          '</div>' +
          '<p class="lux-rc-error" data-rc-error="choice" hidden>Bitte wähle eine Ausführung.</p>';
        // Ausführung als erste Entscheidung: vor die erste App-Option setzen (gleicher Container), sonst an die Stelle des Einbau-Felds
        var firstOpt = info.querySelector('.mw-option');
        var anchor = einbau.root;
        if (firstOpt && firstOpt !== einbau.root) {
          var n = firstOpt;
          while (n && n.parentNode && !n.parentNode.contains(einbau.root)) n = n.parentNode;
          if (n && n.parentNode) anchor = n;
        }
        anchor.parentNode.insertBefore(cards, anchor);
        einbau.root.classList.add('lux-rc-hidden');
        errCards = cards.querySelector('[data-rc-error="choice"]');

        var fire = function (sel) {
          sel.dispatchEvent(new Event('input', { bubbles: true }));
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        };
        var paint = function () {
          cards.querySelectorAll('.lux-rc-card').forEach(function (b) {
            var on = b.getAttribute('data-rc') === ctx.choice;
            b.setAttribute('aria-checked', on ? 'true' : 'false');
            b.classList.toggle('is-selected', on);
            b.tabIndex = (on || (!ctx.choice && b.getAttribute('data-rc') === 'kit')) ? 0 : -1;
          });
          priceValue.textContent = ctx.choice === 'montage' ? money(withTotal) : (ctx.choice === 'kit' ? money(base) : 'ab ' + money(base));
          // mobile Kaufleiste zeigt denselben Preis
          var barPrice = document.querySelector('.lux-pbar__price');
          if (barPrice) barPrice.textContent = priceValue.textContent;
        };
        var choose = function (key, focus) {
          ctx.choice = key;
          einbau.select.selectedIndex = key === 'montage' ? einbau.withIdx : einbau.withoutIdx;
          fire(einbau.select);
          if (errCards) errCards.hidden = true;
          cards.classList.remove('is-invalid');
          paint();
          if (focus) cards.querySelector('[data-rc="' + key + '"]').focus();
        };
        cards.addEventListener('click', function (e) {
          var b = e.target.closest('.lux-rc-card');
          if (b) choose(b.getAttribute('data-rc'));
        });
        // Pfeiltasten wie bei Radiobuttons
        cards.addEventListener('keydown', function (e) {
          if (!/^Arrow(Up|Down|Left|Right)$/.test(e.key)) return;
          e.preventDefault();
          choose(ctx.choice === 'kit' ? 'montage' : 'kit', true);
        });

        // Keine kostenpflichtige Vorauswahl: die App setzt "Mit Montage" als Standard – zurück auf "bitte wählen"
        var sel = einbau.select;
        if (sel.selectedIndex === einbau.withIdx) {
          var placeholder = Array.prototype.findIndex.call(sel.options, function (o) { return !o.value || /wähle|bitte/i.test(o.text); });
          sel.selectedIndex = placeholder > -1 ? placeholder : -1;
          fire(sel);
        } else if (sel.selectedIndex === einbau.withoutIdx) {
          ctx.choice = 'kit';
        }
        paint();
        // Händler (D-032): nur Teilebestellung – Karte "inkl. Einbau" ausblenden, Nachrüstsatz vorwählen (kostenlose Option)
        if (hrRate > 0) {
          var mBtn = cards.querySelector('[data-rc="montage"]');
          if (mBtn) mBtn.hidden = true;
          choose('kit');
        }
      }
    }
    if (!einbau) priceValue.textContent = money(base);

    /* ---------- FIN: sichtbare Pflichtangabe ---------- */
    var errFin = null;
    if (fin) {
      fin.root.classList.add('lux-rc-fin');
      var head = el('div', 'lux-rc-fin__head',
        '<label class="lux-rc-fin__label" for="LuxRcFin">Fahrzeug-Identifizierungsnummer (FIN) <span aria-hidden="true">*</span></label>' +
        '<p class="lux-rc-fin__help" id="LuxRcFinHelp">Bitte gib deine 17-stellige FIN an. Wir prüfen damit vor Bearbeitung deiner Bestellung die Kompatibilität des Nachrüstsatzes mit deinem Fahrzeug. Du findest sie im Fahrzeugschein (Feld E).</p>');
      fin.root.insertBefore(head, fin.root.firstChild);
      if (!fin.input.id) fin.input.id = 'LuxRcFin';
      else head.querySelector('label').setAttribute('for', fin.input.id);
      fin.input.required = true;
      fin.input.setAttribute('aria-required', 'true');
      fin.input.setAttribute('aria-describedby', 'LuxRcFinHelp LuxRcFinError');
      fin.input.setAttribute('autocomplete', 'off');
      fin.input.setAttribute('autocapitalize', 'characters');
      fin.input.setAttribute('spellcheck', 'false');
      fin.input.setAttribute('placeholder', '17 Zeichen, z. B. aus Feld E');
      errFin = el('p', 'lux-rc-error', 'Bitte gib deine vollständige 17-stellige FIN ein (Buchstaben und Ziffern, ohne I, O und Q).');
      errFin.id = 'LuxRcFinError';
      errFin.hidden = true;
      fin.root.appendChild(errFin);

      // Großbuchstaben, Leerzeichen entfernen – ohne den Cursor springen zu lassen
      fin.input.addEventListener('input', function () {
        var v = fin.input.value, up = v.toUpperCase().replace(/\s+/g, '');
        if (up !== v) {
          var pos = fin.input.selectionStart - (v.length - up.length);
          fin.input.value = up;
          try { fin.input.setSelectionRange(pos, pos); } catch (err) { /* ignorieren */ }
        }
        if (VIN_RE.test(up)) { errFin.hidden = true; fin.root.classList.remove('is-invalid'); fin.input.removeAttribute('aria-invalid'); }
      });
    }

    /* ---------- Hinzufügen nur mit Ausführung + gültiger FIN ---------- */
    function validate() {
      var firstBad = null;
      if (einbau && !ctx.choice) {
        errCards.hidden = false;
        cards.classList.add('is-invalid');
        firstBad = firstBad || cards.querySelector('.lux-rc-card');
      }
      if (fin) {
        var v = fin.input.value.trim().toUpperCase();
        if (!VIN_RE.test(v)) {
          errFin.hidden = false;
          fin.root.classList.add('is-invalid');
          fin.input.setAttribute('aria-invalid', 'true');
          firstBad = firstBad || fin.input;
        }
      }
      if (firstBad) {
        var top = firstBad.getBoundingClientRect().top + window.scrollY - 120;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        firstBad.focus({ preventScroll: true });
        return false;
      }
      return true;
    }

    var guard = function (e) {
      var btn = e.target.closest && e.target.closest('.product-info .button-add-to-cart, .product-info [name="add"], .product-info .shopify-payment-button__button');
      if (!btn) return;
      if (!validate()) { e.preventDefault(); e.stopImmediatePropagation(); }
    };
    document.addEventListener('click', guard, true);
    var form = (fin && fin.input.form) || (einbau && einbau.select.form);
    if (form) form.addEventListener('submit', function (e) {
      if (!validate()) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);

    body.classList.add('lux-rc-ready');
  }

  function start() {
    var info = document.querySelector('.product-info');
    if (!info) return;
    var tries = 0;
    var attempt = function () {
      var found = findOptions(info);
      if (found.einbau || found.fin) {
        // kurz warten, bis die App alle Felder gerendert hat
        if (!attempt.settled) { attempt.settled = true; setTimeout(attempt, 250); return true; }
        setup(info, found);
        return true;
      }
      return false;
    };
    if (attempt()) return;
    var mo = new MutationObserver(function () {
      if (++tries > 400) { mo.disconnect(); return; }
      if (attempt()) mo.disconnect();
    });
    mo.observe(info, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
